/**
 * Кнопка кэшаута
 */

import { Button } from './Button';
import { COLORS } from '@/config/colors';
import type { Lang } from '@/utils/storage';

const TEXTS = {
  ru: { cashout: 'CASH\nOUT' },
  en: { cashout: 'CASH\nOUT' },
};

export class CashoutButton extends Button {
  constructor() {
    super({
      width: 80,
      height: 80,
      radius: 40,
      fillColor: COLORS.buttonSecondary,
      text: TEXTS.en.cashout,
      fontSize: 14,
    });
  }

  setLang(lang: Lang): void {
    this.setText(TEXTS[lang].cashout);
  }
}
